import { Box, Stack, Typography } from "@mui/material";
import { RewardsSummaryItem } from "Components/Loyalty/RewardsSummary/RewardsSummaryItem";
import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.UserMenu.Rewards;

type Props = {
  totalRewards: string | number;
  totalPoints: string | number;
  totalPointsLabel: string;
  myShare: string | number;
};

export const RewardsSummary = ({
  totalRewards,
  totalPoints,
  totalPointsLabel,
  myShare,
}: Props) => {
  const { t } = useResource();
  const { isUserInMooneLite } = useIsUserInMooneLite();

  return (
    <Box p={3}>
      <Stack gap={0.5}>
        {isUserInMooneLite && (
          <Typography fontWeight="bold" mb={2}>
            {t(Resources.UserMenu.MooneLiteInfo)}
          </Typography>
        )}
        <Box sx={{ opacity: isUserInMooneLite ? 0.5 : 1 }}>
          <RewardsSummaryItem
            title={t(RESOURCES.TotalRewards)}
            value={totalRewards}
          />
          <RewardsSummaryItem title={totalPointsLabel} value={totalPoints} />
          <RewardsSummaryItem
            title={t(RESOURCES.MyShare)}
            value={myShare}
            isBold
          />
        </Box>
      </Stack>
    </Box>
  );
};
